// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-card[data-v-178f6c52] {\n  background-color: #fff;\n  border-radius: 3px;\n  border-color: #e2e2e2;\n  width: 214px;\n  margin-left: 2px;\n  position: absolute;\n  border-width: 1px;\n  border-style: solid;\n  margin-top: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
